<template>
  <div class="app-container">
    <list ref="list">
      <template slot="column">
        <!-- <el-table-column label="操作" fixed="right" align="center" width="90">
          <template slot-scope="{row}">
            <el-button type="text" @click="openPrint(row)">打印</el-button>
            <el-button type="text" @click="openPrintWithSend(row)">发货</el-button>
          </template>
        </el-table-column> -->
      </template>
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/refundorders/list";

export default {
  name: "refundorders",
  mixins: [curdMixins],
  components: { list },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {


  }
}
</script>
<style lang="scss"></style>